module.exports = __webpack_public_path__ + "c63a280f2a3ac36c0ddcf68a65850a11.png";